import React from 'react'
import "./TPMS_4.css"
function TPMS_4() {
  return (
    <>
    <div className='container-fluid solutionbg'>
    <div className='row'>
        <div className='col-12 col-sm-6 col-md-6'>
            <h6 className='text-dark small_heads'>THE SOLUTION</h6>
            <h1 className='soluhead fw-bold1 '> Introducing TPMS – <br></br>Smart Toll Monitoring Solution</h1>
            <div className='padpp '>
            <p className='fw-bold'>TPMS is a next-generation AI-powered toll monitoring system that 
automates, monitors, and optimizes toll operations in real-time.</p>
<p className='fw-bold'>
    With intelligent surveillance, OCR-based vehicle detection, and centralized 
analytics, TPMS ensures: 
</p>
</div>
        </div>
        <div className='col-12 col-sm-6 col-md-6'>
            <div className='bgq'>
            <div>
                <img
                src='/ImagesNew/Hero-Image-2-LR.png'
                alt='img'
                className='p-5 soluimg1 '
                />
                </div>
            </div>
            <div className='solufeature'>
            <span>✔ Accurate Toll Collection</span>
            <span>✔ Real-Time Monitoring</span>
            <span>✔ Fraud Detection</span>
            <span>✔ Data-Driven Decisions</span>
            </div>
        </div>

    </div>
    </div>
    </>
  )
}

export default TPMS_4
